import React from "react" ;
import ResourcesAppBodyHeader from "./ResourcesAppBodyHeader";
import {Route, Switch} from "react-router-dom";

import {PATH_RESOURCES_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import ResourcesTab from "root/Wieldy/ApplicationModules/Resources/Body/ResourcesTab";

const ResourcesAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <ResourcesAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_RESOURCES_ROOT}render={(thisprops) => <ResourcesTab resource_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default ResourcesAppBody;
